// extracted by mini-css-extract-plugin
module.exports = {"ArrowButton":"style_ArrowButton__3vKSF"};